export function toSnakeCase(str: string): string {
  return str.trim().replace(/\s+/g, '_').toLowerCase();
}

export const capitaliseFirstLetter = (text: string): string =>
  text.charAt(0).toUpperCase() + text.slice(1);